/* 
- Algolia returns one or more industry examples (which include a title and a naics code)
- Stores this JSON object as algoliaResults
 */
import algoliasearch from "algoliasearch";

export function getConnexion(indexName, term) {
  // algolia search
  var appid = "IQKSBFPSWC";
  var secret = "f8aab81f78e6415f1ea46a4c80c1eb20";
  var client = algoliasearch(appid, secret);
  var index = client.initIndex(indexName);

  return index
    .search(term)
    .then(({ hits }) => {
      return hits
    });
}
